// AdminDashboard.tsx
import React, { useEffect, useState } from 'react';
import { Container, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import { adminCloak, adminListDashboardUsers } from '../clients/FixieApiClient';
import { useNavigate } from 'react-router-dom';

// Define the types for the DashboardUser
interface DashboardUser {
  id: string;
  email: string;
  role: string;
}

// The AdminDashboard Component
export default () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState<DashboardUser[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch the dashboard users from the backend
  const fetchUsers = async () => {
    const response = await adminListDashboardUsers();
    if (response.ok) {
      const dashboardUsers = await response.json()
      setUsers(dashboardUsers);
      setLoading(false);
    }
  };

  // Cloak as the selected user
  const handleCloak = async (userId: string) => {
    try {
      const response = await adminCloak({ userId });
      if (response.ok) {
        navigate('/apps')
      }
    } catch (err) {
      console.error('Error cloaking as user:', err);
      setError('Failed to cloak as the selected user');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Admin Dashboard - Cloak as a User
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleCloak(user.id)}
                      disabled={user.role === 'FixieAdmin'} // Prevent cloaking as another admin
                    >
                      Cloak
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};
